import * as React from "react";
import { IconChevron, Button, List } from "atoms";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
} from "features/layouts/components/SiteHeader";
import { useToggle } from "utils/hooks";
import type { ReviewSortOption } from "../types";

const sortOptions: [ReviewSortOption, string][] = [
  ["createdAt desc", "Newest"],
  ["createdAt", "Oldest"],
];

interface ReviewSortProps {
  createHandler: (option: ReviewSortOption) => VoidFunction;
  isModerationPage?: boolean;
}

const useReviewSort = (defaultOption?: ReviewSortOption) => {
  const [activeReviewSort, setActiveReviewSort] =
    React.useState<ReviewSortOption>(defaultOption ?? sortOptions[0][0]);

  const createReviewSortHandler = (option: ReviewSortOption) => () => {
    setActiveReviewSort(option);
  };

  return { activeReviewSort, createReviewSortHandler };
};

function ReviewSort({
  createHandler,
  isModerationPage = false,
}: ReviewSortProps) {
  const [isOpen, toggle, setIsOpen] = useToggle(false);

  // If user selects menu option, the menu should close after event bubbles up
  const close: React.ReactEventHandler = (event) => {
    if (event.currentTarget !== event.target) {
      setIsOpen(false);
    }
  };

  return (
    <Dropdown isOpen={isOpen}>
      <DropdownToggle onClick={toggle} aria-expanded={isOpen}>
        <Button variant="secondary" size="xs" as="div">
          Sort <IconChevron size=".75em" />
        </Button>
      </DropdownToggle>
      <DropdownMenu onClick={close}>
        <List type="blank">
          {sortOptions
            .filter(
              (entry) => !(isModerationPage && entry[0] === sortOptions[0][0])
            )
            .map(([option, label]) => (
              <li key={option}>
                <Button variant="blank" onClick={createHandler(option)}>
                  {label}
                </Button>
              </li>
            ))}
        </List>
      </DropdownMenu>
    </Dropdown>
  );
}

export { ReviewSort, useReviewSort };
